import { render, staticRenderFns } from "./ProspectForm.vue?vue&type=template&id=0ef27fd6&"
import script from "./ProspectForm.vue?vue&type=script&lang=js&"
export * from "./ProspectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports